import React from 'react';
import PropTypes from 'prop-types';

const ShowAllTableButton = ({showAll, handleShowHideClick }) => {

  return (
      <div>
         {!showAll && <button className='link-button' onClick={()=>handleShowHideClick(true)}>Sýna alla töflu</button>}
         {showAll && <button className='link-button' onClick={()=>handleShowHideClick(false)}>Fela</button>}
      </div>
  );

};

ShowAllTableButton.propTypes = {
  showAll: PropTypes.bool.isRequired,
  handleShowHideClick : PropTypes.func.isRequired  
};

export default ShowAllTableButton;

